import backgroundVideo from "../../assets/images/backgroundProducts.mp4";
import "./style.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { img22, img23, img24, img25, img26, img27, img28, img29, img30 } from "../../assets/images/ibs"

const ibsDetails = {
    name: "IBS (Integrated Business Suite)",
    description: "Introducing our all-in-one Business Strategy and Collaboration Platform to enhance organizational efficiency. It features goal tracking, real-time collaboration, CRM, finance management, and resource allocation. With integrated meeting and MOM modules, profitability analysis, and mobile access, the platform streamlines planning, execution, and communication while ensuring security and ease of use.",
    images: [img22, img23, img24, img25, img26, img27, img28, img29, img30],
}
const IntegratedBusinessSuite = () => {
    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 1,
        speed: 500
      };
    return (
        <div className="w-full relative h-full">
      {/* Background Section */}
      <section id="heading" className="relative flex">
        {/* Background Video */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={backgroundVideo}
          autoPlay
          loop
          muted
          style={{ opacity: "0.25" }}
        />

        {/* Heading Content */}
        <div className="relative max-w-7xl mx-auto flex flex-col items-center justify-center h-screen z-10">
          <h1 className="text-4xl lg:text-5xl font-bold text-center text-white">
            <span className="gradient-headings">{ibsDetails.name}</span>
          </h1>
          <p className="text-xl lg:text-2xl text-white mt-6 mx-auto max-w-4xl px-4 text-justify md:text-center">
            Introducing our all-in-one Business Strategy and Collaboration Platform to enhance organizational efficiency. It features goal tracking, real-time collaboration, CRM, finance management, and resource allocation.
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="pb-10 px-4 md:px-8 bg-gradient-to-r from-slate-950/80 via-slate-950/90 to-slate-950/100">
        <div className="container mx-auto flex flex-col-reverse md:flex-col   gap-10 xl:gap-16 items-center">
          <div className="text-base lg:text-xl text-white px-4 xl:mt-24">
            <p className="text-justify">{ibsDetails.description}</p>
          </div>
          <div className="w-full px-4 slider-container">
            <Slider {...settings}>
              {ibsDetails.images.map((image, index) => (
                <div key={index} className="">
                  <img
                    src={image}
                    alt="product images"
                    className="w-full h-auto rounded-lg shadow-lg object-cover"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>


      
    </div>
    )
}

export default IntegratedBusinessSuite